// import MediaPicker from '/modules/DELETE---media/picker';
import MaskedInput from 'react-maskedinput';
import CurrencyInput from 'react-currency-input-field';
import React from 'react';
// import i18n from 'utils/i18n';

import css from './styles.module.scss';

import {
  Checkbox,
  TextArea,
  // Form,
  Input,
  Dropdown,
  Popup,
  Icon,
  Label,
  Button,
  Loader
} from 'semantic-ui-react';
import Editor from 'components/molecules/editor';
import TagInput from '../tag-input';
// import AceEditor from "react-ace";
import DynamicPicker from 'components/atoms/dynamic-picker';
import Range from 'components/atoms/range';
import ColorPicker from 'components/molecules/color-picker';
import LookupPicker from '/components/atoms/lookup-picker';
import { isNullish, nullOrValue } from '/utils/functions';
import IconSelector from '/utils/hocs/icons-selector';
import CodeEditorPicker from '/modules/code-editor/picker';
import { createFakeEvent, formatDateForInput, getExtensionsForType, isDate, isFunction, toArray }
  from '@/utils/functions';
import PickerPicker from '@/components/atoms/picker-picker';
// import AddressPicker from '@/modules/address-picker';
import AddressPickers from '../address-picker';
const DEFAULT_TYPE = "text";

/**
 * Molecule InputControl
 *
 * A control to be used in multiple places. It will adapt itself to different types of controls.
 */
function InputControl (props) {
  // const gt = i18n.useTranslations('global');
  // const t = i18n.useTranslations('components.input-control');

  const [editorSimpleMode, setEditorSimpleMode] = React.useState(false);
  const [editingWithConfirm, setEditingWithConfirm] = React.useState(false);
  const [localValue, setLocalValue] = React.useState("");

  const theInputRef = React.useRef();

  // TODO: move this (and the editor input) to a separate file/component, for better perf
  function updateEditorMode (event, target) {
    setEditorSimpleMode(target.value);
  }

  const {
    // className = "",
    children,
    type = DEFAULT_TYPE,
    label = "",
    onAddItem,
    onAdd,
    multiple,
    mask,
    maskProps = {},
    options,
    apis,
    inputProps,
    helperText = null,
    help,
    nested,
    disabled,
    size,
    full,
    small,
    minimum,
    loading,
    confirmOnChange = false,
    upward,
    devMode,
    action = null,
    onChange = _ => {},
    fieldProps = {},
    ...other
  } = props;

  let [typeRoot, typeDetail] = type.split(':');
  if (!typeDetail) {
    typeDetail = typeRoot;
  }

  const isFull = (size === 'full' || full);
  const isSmall = (size === 'small' || small);
  const isMinimum = (size === 'minimum' || minimum);
  const shouldBreak = (size === 'break' || minimum);

  const helpComp = help
    ? (
      <Popup
        content={help}
        offset={[-5, 0]}
        trigger={(
          <Icon
            name='question circle outline'
            className={css['helper-trigger']}
          />
        )}
      />
    )
    : null;

  function checkValueOnChange (event, target) {

    target = target || event.target;

    if (['numeric', 'number', 'float', 'int', 'integer'].includes(type)) {
      const value = multiple
        ? target.value.map(item => parseFloat(item.value || item))
        : parseFloat(target.value);
      target.value = value;
      event.target.value = value;
    }

    if (nested) {
      target.nested = nested;
      event.target.nested = nested;
    }

    onChange(event, target);
  }

  function getHelperText () {
    if (!helperText) {
      return null;
    }
    if (typeof helperText == 'function') {
      return helperText();
    }
    return helperText;
  }

  switch (typeRoot?.toLowerCase()) {
  case "address":
  case "addr":
    return <div
      className={"field " + css.field + ' ' + css.separator}
      data-kind={other.kind}
      data-full={true}
    >
      <AddressPickers
        apis={apis}
        onDone={(addrData) => {
          const evt = createFakeEvent(
            other.name,
            addrData,
            {scope: other.scope}
          );

          onChange(evt, evt.target);
        }}
        label={label}
        {...other}
      />
    </div>;

  case "message":
  case "separator":
  case "decorator":
    return <div
      className={"field " + css.field + ' ' + css.separator}
      data-kind={other.kind}
      data-full={true}
    >
      <label>
        { label || other.name }
      </label>
    </div>;
  case "bool":
  case "boolean":
  case "switch":
  case "checkbox":
  case "toggle": {
    const {
      value,
      defaultValue,
      checked,
      onLabel,
      offLabel,
      showLabels = false,
      ...rest
    } = other;
    let isChecked = value !== undefined
      ? !!value
      : (
        checked !== undefined
          ? checked
          : !!defaultValue
      );

    return (
      <div
        className={"field " + css.field + ' ' + css.switch}
        data-full={isFull ? 1 : null}
        data-small={isSmall ? 1 : null}
        data-minimum={isMinimum ? 1 : null}
        data-break={shouldBreak ? 1 : null}
      >
        {showLabels && label && <label>
          {label}{other.required ? "*" : ""}{helpComp}
        </label>}
        <Checkbox
          toggle
          label={
            showLabels
              ? ((isChecked ? onLabel : offLabel) || "")
              : label
          }
          disabled={disabled}
          checked={isChecked}
          onLabel={onLabel}
          offLabel={offLabel}
          showLabels={showLabels}
          onChange={(event, data) => {
            const target = {
              value: !!data.checked,
              checked: !!data.checked,
              name: other.name
            };
            onChange({
              ...event,
              target,
            }, target);
          }}
          {...rest}
        >
          {children}
        </Checkbox>
      </div>
    );
  }
  case "textarea":
  case "long": {
    return (
      <div
        className={"field " + css.field}
        data-full="1"
      >
        {
          label && (
            <label>
              {label}{other.required ? "*" : ""}{helpComp}
              {loading && (
                <Loader
                  active
                  inline
                  size='tiny'
                  style={{marginLeft: '1rem'}}
                />
              )}
            </label>
          )}
        <TextArea
          {...other}
          onChange={event => {
            return onChange(event, event.target);
          }}
          style={{width: '100%'}}
          readOnly={other.readOnly || loading}
          defaultvalue={nullOrValue(other.value, '')}
          // defaultvalue={other.value || ''}
        >{children}</TextArea>
      </div>
    );
  }
  case "richtext":
  case "rich":
  case "editor":
  case "wysiwyg": {
    return <div data-full="1">
      <div className={"field " + css['editor-label']}>
        {label && <label>{label}{other.required ? "*" : ""}</label>}
        <label className={css['tool']}> {   }
          (
          menu&nbsp;
          <InputControl
            type="boolean"
            name="editorMode"
            value={!!editorSimpleMode}
            onChange={updateEditorMode}
          />
          icons
          )
        </label>
      </div>
      <Editor
        onChange={onChange}
        menu={!editorSimpleMode}
        icons={!!editorSimpleMode}
        {...other}
      />
    </div>;
  }
  case "btn":
  case "button": {
    return <div
      className={"field " + css.field}
      data-full={isFull ? 1 : null}
      data-small={isSmall ? 1 : null}
      data-minimum={isMinimum ? 1 : null}
      data-break={shouldBreak ? 1 : null}
    >
      <Button
        {...other}
      />
    </div>;
  }
  case "money":
  case "price":
  case "cost":
  case "currency": {
    return <div
      className={"field " + css.field}
      data-full={isFull ? 1 : null}
      data-small={isSmall ? 1 : null}
      data-minimum={isMinimum ? 1 : null}
      data-break={shouldBreak ? 1 : null}
    >
      {label && <label>{label}{other.required ? "*" : ""}</label>}
      <Label tag size="large" style={{padding: '.25rem'}}>
        <CurrencyInput
          placeholder="Please enter a number"
          decimalsLimit={ other.precision }
          // fixedDecimalLength={ other.precision }
          decimalScale={ other.precision }
          prefix={other.prefix || '$'} // TODO: use `symbol` from __config/i18n
          style={{backgroundColor: 'transparent', border: 'none'}}
          onValueChange={(value, name) => {
            const target = {name, value};
            onChange && onChange({target}, target);
          }}
          { ...other }
        />
      </Label>
    </div>;
  }
  case "file":
  case "image":
  case "upload":
  case 'drive': {
    return <div className={"field " + css.field} style={{flexGrow: 1}}>
      {/* {label && <label>{label}{other.required ? "*" : ""}</label>} */}
      <InputControl
        {...props}
        // label={null}
        apis={apis}
        type="picker"
        src="Drives"
        hideLabel={props.hideLabel}
        options={{
          ...(props.options || {}),
          picker: typeDetail,
          contexts: props.contexts || props.options?.contexts,
          context: (props.contexts || props.options?.contexts || [])[0],
          type: props.options?.accepts || '*',
          types: getExtensionsForType(props.accepts)
        }}
      />
    </div>;
    // const { value } = other;
    // return (
    //   <div
    //     className={"field " + css.field}
    //     data-full={isFull ? 1 : null}
    //     data-small={isSmall ? 1 : null}
    //     data-minimum={isMinimum ? 1 : null}
    //     data-break={shouldBreak ? 1 : null}
    //   >
    //     {label && <label>{label}{other.required ? "*" : ""}</label>}
    //     <MediaPicker
    //       defaultCurrent={value?.id || value}
    //       apis={apis}
    //       handleSelect={(media) =>  {
    //         let value = media;
    //         if (other.name?.endsWith('Id')) {
    //           value = media?.id;
    //         }

    //         const target = {
    //           name: other?.name || other?.id,
    //           value
    //         };

    //         onChange({ target }, target);
    //       }}
    //     />
    //   </div>)
    // ;
  // }
  }
  case "list":
  case "pdf":
  case "doc":
  case "document":
  case "word":
  case "txt":
  case "spreadsheet":
  case "table":
  case "csv":
  case "excel":
  case "sheet": {
    const { value } = other;
    const isPDF = ['pdf'].includes(typeRoot?.toLowerCase());
    const isDoc = ['word', 'doc'].includes(typeRoot?.toLowerCase());
    const isSheet = ['sheet', 'table', 'spreadsheet', 'csv', 'excel', 'list']
      .includes(typeRoot?.toLowerCase());
    const icon = isPDF
      ? "file pdf outline"
      : (isDoc
        ? "file word outline"
        : (
          isSheet
            ? "table"
            : "file text")
      );
    return (
      <div
        className={"field " + css.field}
        data-full={isFull ? 1 : null}
        style={{position: 'relative'}}
      >
        {label && <label>{label}{other.required ? "*" : ""}</label>}
        <Input
          type={"file"}
          onChange={checkValueOnChange}
          {...other}
          value={value || ''}
          autoComplete="off"
          // inputProps={inputProps}
          required={other.required}
          icon={icon}
          iconPosition='left'
          accept={`.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel`}
        />
      </div>)
    ;
  }
  case 'slide':
  case 'slider':
  case 'rule':
  case 'range': {
    return (
      <div
        className={"field " + css.field}
        style={{flexGrow: 1}}
        data-full={isFull ? 1 : null}
        data-small={isSmall ? 1 : null}
        data-minimum={isMinimum ? 1 : null}
        data-break={shouldBreak ? 1 : null}
      >
        {label && <label>{label}{other.required ? "*" : ""}</label>}
        {
          helperText && <><br/><small>{helperText}</small><br/><br/></>
        }
        <div className={css['range-container']}>
          <Range
            {...props}
            allowOverlap
          />
        </div>
      </div>
    );
  }
  case 'custom': {
    return (
      <div className={"field " + css.field}
        style={{flexGrow: 1}}
        data-full={isFull}
        data-small={isSmall ? 1 : null}
        data-minimum={isMinimum ? 1 : null}
        data-break={shouldBreak ? 1 : null}
      >
        {label && <label>{label}{other.required ? "*" : ""}</label>}
        {
          helperText && <><br/><small>{helperText}</small><br/><br/></>
        }
        {/* <div className={css['custom-input-container']}> */}
        {children}
        {/* </div> */}
      </div>
    );
  }
  case 'picker': {
    return <DynamicPicker
      {...props}
    />;
  }
  case 'pickers': {
    return <PickerPicker
      {...props}
    />;
  }
  case 'datastructure':
  case 'lookup': {
    return <LookupPicker
      {...props}
    />;
  }
  case 'icon': {
    return <IconSelector
      {...props}
    />;
  }
  case 'code': {
    return <CodeEditorPicker
      {...props}
    />;
  }
  case 'color':
  case 'colour':
  case 'rgb':
  case 'duocolor':
  case 'dualcolor': {
    return <ColorPicker
      {...props}
    />;
  }
  // case 'date':
  // case 'datetime-local':
  // case 'time': {
  //   return <>
  // }
  default: {
    // this is here to avoid that annoying react warning of inputs that change
    // from uncontrolled to controlled
    let value = isNullish(other.value)
      ? other.onChange ? (other.defaultValue || "") : undefined
      : other.value;

    const tRoot = typeRoot?.toLowerCase();
    if (tRoot.startsWith('date') || tRoot === 'time') {
      if (value && !isDate(value)) {
        // debugger; console.log(123, value)
        // debugger; console.log(456, (new Date(value)).getTime())
        try {
          /**
           * This is to prevent Javascript take a day off 
           * from the date selected by the user
           */
          if(tRoot === 'time') {
            value = formatDateForInput(new Date(value));
          } else {
            const date = value.split('-');

            value = formatDateForInput(new Date(date[0], date[1], date[2]));
          }

        } catch (error) {
          // ignoring and using the received value as it is
        }
      }
    }

    function parseOptionItem (item) {
      if (typeof item !== 'object') {
        return { key: item, value: item, text: item };
      }

      return {
        // ...item,
        key: item.key || item.value,
        value: item.value,
        text: item.text
          || item.label
          || item.name
          || item.title
          || item.value
      };
    }

    // it is a combo/select box
    let theOptions = options;
    if (isFunction(theOptions)) {
      theOptions = theOptions(props.values);
    }

    if (Array.isArray(theOptions)) {
      let options = theOptions;
      const {
        readOnly,
        asObject,
        defaultValue,
        ...dropDownRest
      } = other;

      let theValue = isNullish(value) ? null : value;
      if (multiple) {
        theValue = toArray(theValue);
        // if (!Array.isArray(theValue)) {
        //   theValue = value ? [value] : [];
        // }
      }

      if (asObject) {
        theValue = multiple
          ? theValue.map(v => v?.value || v)
          : theValue?.value;
      }

      const theFunc = onAddItem || onAdd;

      return (
        <div className={"field " + css.field} style={{flexGrow: 1}}>
          {
            other.required
              && (
                <input
                  type="text"
                  value={value?.toString() || ""}
                  className='hidden-input'
                  required
                />
              )
          }
          {label && <label>{label}{other.required ? "*" : ""}</label>}
          <Dropdown
            fluid
            deburr
            multiple={multiple}
            search
            defaultOpen={false}
            selection
            clearable
            loading={props.loading || other.loading}
            closeOnChange
            selectOnBlur={false}
            allowAdditions={!!theFunc}
            onAddItem={(event, target) => {
              if (theFunc) {
                theFunc && theFunc(event, target);
              } else {
                // TODO ?
              }
            }}
            disabled={disabled || readOnly}
            scrolling
            floating
            options={
              options.map(item => {
                return parseOptionItem(item);
              })
            }
            upward={upward || other.upward || false}
            {...dropDownRest}
            value={theValue || (multiple ? [] : '')}
            onChange={(event, target) => {
              if (readOnly || !onChange) { return; }
              target = target || event.target;

              if (asObject) {
                if (multiple) {
                  target.value = target.value
                    .map(targetVal => {
                      return options.find(o => o.value === targetVal)
                        || targetVal;
                    });
                } else {
                  target.value = options.find(o => o.value === target.value)
                    || target.value;
                }
              }

              checkValueOnChange({
                ...event,
                target
              }, target);
            }}
          />
          {
            helperText
              ? <sub className={css['helper-text']}><br/>{getHelperText()}</sub>
              : null
          }
        </div>
      );
    }

    // if it is multiple but has no options (not event an empty array)
    // we will treat it as a tagged input (it will behave like an array)
    if (multiple) {
      return (
        <TagInput
          label={label}
          // value={value}
          onChange={!other.readOnly && onChange}
          {...other}
        />
      );
    }

    // it is an input
    const maskParams = {
      mask,
      guide: true,
      onChange: !other.readOnly && onChange,
      value,
      placeholder: other.placeholder,
      ...maskProps
    };

    return (
      <div
        className={"field " + css.field}
        data-full={isFull ? 1 : null}
        data-small={isSmall ? 1 : null}
        data-minimum={isMinimum ? 1 : null}
        data-break={shouldBreak ? 1 : null}
      >
        {
          label && <label>{label}{other.required ? "*" : ""}</label>
        }
        <Input
          type={typeDetail}
          onChange={
            confirmOnChange
              ? (editingWithConfirm === 1 &&
                ((event, target) => { setLocalValue(target.value); }))
              : checkValueOnChange
          }
          {...other}
          {...fieldProps}
          maxLength={other.maxLength || other.max}
          value={(confirmOnChange ? localValue || value : value) || ''}
          autoComplete="off"
          style={{width: '100%'}}
          // inputProps={inputProps}
          action={action || !!confirmOnChange}
          data-confirm-on-change-loading={
            confirmOnChange &&
            editingWithConfirm === 'loading'
              ? 1
              : null
          }
          data-confirm-on-change-editing={
            confirmOnChange &&
            editingWithConfirm
              ? 1
              : null
          }
          data-confirm-on-change={
            confirmOnChange ? 1 : null // && !editingWithConfirm ? 1 : null
          }
          // action={
          //   confirmOnChange
          //     ? ({ icon: 'edit' })
          //     : undefined
          // }
          // disabled={other.readOnly ||confirmOnChange}
          readOnly={
            other.readOnly
            || (
              confirmOnChange
              && (!editingWithConfirm || editingWithConfirm === 'loading')
            )
          }
        >
          {
            mask
              ? (
                <MaskedInput
                  name={other.name}
                  type={typeDetail}
                  {...maskParams}
                  onChange={checkValueOnChange}
                />
              )
              : <input ref={theInputRef} />
          }
          {
            confirmOnChange
              ? (<>
                {/* <input /> */}
                {
                  editingWithConfirm
                    ? <>
                      <Button
                        icon="cancel"
                        style={{color: 'red'}}
                        onClick={_ => {
                          setEditingWithConfirm(null);
                          setLocalValue(value);
                        }}
                      />
                      <Button
                        icon="check"
                        color="green"
                        loading={editingWithConfirm === 'loading'}
                        onClick={(event, target) => {
                          setEditingWithConfirm('loading');
                          target = theInputRef.current;
                          // target = event
                          //   .target
                          //   .parentElement
                          //   .querySelector('input');
                          event.target = target;
                          event.loading = true;
                          event.onDone = _ => {
                            setEditingWithConfirm(false);
                          };
                          checkValueOnChange(event, target);
                        }}
                      />
                    </>
                    : (
                      <Button
                        icon={editingWithConfirm ? "check": "edit"}
                        className={css['confirm-edit-btn']}
                        color={
                          editingWithConfirm ? 'green' : undefined
                        }
                        loading={editingWithConfirm === 'loading'}
                        basic={!editingWithConfirm}
                        inverted={!editingWithConfirm}
                        attached="right"
                        onClick={(event, target) => {
                          theInputRef.current.focus();
                          setEditingWithConfirm(1);
                        }}
                      />
                    )
                }
              </>)
              : null
          }
        </Input>
        {
          helperText
            ? <sub className={css['helper-text']}><br/>{getHelperText()}</sub>
            : null
        }
      </div>
    );
  }}
}


export default InputControl;
